export default class DivisionActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_DIVISION='GET_HELPER_DIVISION';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: DivisionActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: DivisionActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: DivisionActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: DivisionActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: DivisionActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: DivisionActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: DivisionActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: DivisionActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: DivisionActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: DivisionActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: DivisionActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: DivisionActions.GET_HELPER_DIVISION,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: DivisionActions.ERROR_SERVER,
      payload: error
    };
  }
}